import { Text } from '@chakra-ui/react'
import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import { formatNumberWithPunctuation } from 'utils/transforms/number'

export default function CustomFormNumberAnswer() {
  const { answer } = useCustomFormAnswer()

  return (
    <CustomFormEmptyAnswerFeedback>
      <Text color="primary">{formatNumberWithPunctuation(Number(answer.answer && answer.answer[0]))}</Text>
    </CustomFormEmptyAnswerFeedback>
  )
}
